var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sort-by-button", {
        staticClass: "activitylog-tab__sortby-button",
        attrs: { disableSortBy: true },
      }),
      _vm._v(" "),
      _vm.emptyResponse
        ? _c(
            "empty-state",
            _vm._g(
              {
                staticClass: "activitylog-tab__empty-message",
                attrs: { "empty-state": _vm.emptyMessage, view: _vm.view },
              },
              _vm.$listeners
            )
          )
        : _c(
            "div",
            { staticClass: "activitylog-tab__cards" },
            _vm._l(_vm.activityLogs, function (activity, index) {
              return _c("activity-card", {
                key: index,
                attrs: { activity: activity, view: _vm.view },
              })
            }),
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }